import { render } from "./UserActivityList.vue?vue&type=template&id=72c3b195&scoped=true"
import script from "./UserActivityList.vue?vue&type=script&lang=js"
export * from "./UserActivityList.vue?vue&type=script&lang=js"

import "./UserActivityList.vue?vue&type=style&index=0&id=72c3b195&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c3b195"]])

export default __exports__